const translationsFields = `translations {
		uri
		language {
			locale
			code
		}
	}`;

export default translationsFields;
